export const AJZ = 'ajz'
export const ALTENTE = 'altente'
export const TVBET = 'tvbet'
export const BETSOLUTIONS = 'betsolutions'
export const ICONIC = 'iconic'
export const WAZDAN = 'wazdan'
export const MANCALA = 'mancala'
export const GAME_BEAT = 'gamebeat'
export const YEEBET_GAMING = 'yeebetgaming'
export const RFRANKO = 'rfranko'
export const MASCOT = 'mascot'
export const TOMHORN = 'tomhorn'
export const SOFTSWISS = 'softswiss'
export const SPRIBE = 'spribe'
export const BACCARAT_CATEGORY = 'BACCARAT'
export const ROULETTE_CATEGORY = 'ROULETTE'
export const BLACK_JACK_CATEGORY = 'BLACK_JACK'
export const SLOTS_CATEGORY = 'SLOTS'
export const POKER_CATEGORY = 'POKER'
export const CRASH_CATEGORY = 'CRASH'

export const EGameCategories = [
  BACCARAT_CATEGORY,
  ROULETTE_CATEGORY,
  BLACK_JACK_CATEGORY,
  SLOTS_CATEGORY,
  POKER_CATEGORY,
  CRASH_CATEGORY
]
export const ProvidersIds = [
  AJZ,
  ALTENTE,
  TVBET,
  BETSOLUTIONS,
  ICONIC,
  WAZDAN,
  MANCALA,
  GAME_BEAT,
  YEEBET_GAMING,
  RFRANKO,
  SOFTSWISS,
  MASCOT,
  TOMHORN,
  SPRIBE
]
